import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client';
const MAX_BEHAVIORAL_EVENTS = 500;

/**
 * Fetches unified event metadata for all events
 */
export const GET_ALL_EVENT_METADATA = registerQuery({
  fieldName: 'unifiedEventAllMetadata',
  fetcher() {
    return http.get(`inbounddb-meta/v1/object-types/events/for-portal`);
  }
});

/**
 * Fetches CBE data
 *
 */
export const GET_BEHAVIORAL_EVENTS = registerQuery({
  fieldName: 'behavioralEvents',
  args: ['objectTypeId'],
  fetcher({
    objectTypeId
  }) {
    return http.get('behavioral-events/v3/event-definitions', {
      query: {
        primaryObjectTypeId: objectTypeId,
        includeProperties: false,
        limit: MAX_BEHAVIORAL_EVENTS
      }
    });
  }
});
/**
 * Fetches CBE available object types
 */
export const GET_BEHAVIORAL_EVENT_OBJECT_TYPES = registerQuery({
  fieldName: 'behavioralEventObjectTypes',
  fetcher() {
    return http.get('behavioral-events/v3/event-definitions/enabled-object-types');
  }
});

/**
 * Fetches Integrator data
 */
export const GET_INTEGRATOR_EVENTS = registerQuery({
  fieldName: 'integratorEvents',
  fetcher() {
    return http.get('integrators/timeline/v3/portal-installs/event-types').then(resp => {
      return resp;
    });
  }
});